import { EntInitialFilterName } from "../../../models/filters/initialFilterName";
import { EntGovernment } from "../../../models/handBooks/government";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { agroApi } from "../api";
import { Paths } from "../../../paths";

export const governmentApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getGovernmentList: builder.query<ResponseDataGet<EntGovernment>, EntInitialFilterName>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.governments }/get-all`,
		method: "POST",
		body: JSON.stringify(filter)
	  }),
	}),
	getGovernmentById: builder.query<ResponseDataGet<EntGovernment>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.governments }/${ id }`,
		method: 'GET'
	  })
	}),
	addGovernment: builder.mutation<ResponseDataGet<EntGovernment>, EntGovernment>({
	  query: (body) => ({
		url: `${ Paths.handbooks.governments }`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editGovernment: builder.mutation<ResponseDataGet<EntGovernment>, EntGovernment>({
	  query: (body,) => ({
		url: `${ Paths.handbooks.governments }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteGovernment: builder.mutation<ResponseDataGet<EntGovernment>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.governments }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddGovernmentMutation,
  useDeleteGovernmentMutation,
  useEditGovernmentMutation,
  useLazyGetGovernmentListQuery
} = governmentApi;
